var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.458644 7.41034C0.784339 7.11178 1.29039 7.13379 1.58895 7.45948L6.49922 12.8161L11.4095 7.45948C11.7081 7.13379 12.2141 7.11178 12.5398 7.41034C12.8655 7.70889 12.8875 8.21494 12.5889 8.54064L7.08895 14.5406C6.93742 14.7059 6.72347 14.8001 6.49922 14.8001C6.27498 14.8001 6.06103 14.7059 5.9095 14.5406L0.4095 8.54064C0.110946 8.21494 0.132949 7.70889 0.458644 7.41034Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.65144 0.305908C7.20373 0.305908 7.65144 0.753623 7.65144 1.30591V12.3059C7.65144 12.8582 7.20373 13.3059 6.65144 13.3059C6.09916 13.3059 5.65144 12.8582 5.65144 12.3059V1.30591C5.65144 0.753623 6.09916 0.305908 6.65144 0.305908Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.999223 19.0001C0.999223 18.4478 1.44694 18.0001 1.99922 18.0001H11.9992C12.5515 18.0001 12.9992 18.4478 12.9992 19.0001C12.9992 19.5523 12.5515 20.0001 11.9992 20.0001H1.99922C1.44694 20.0001 0.999223 19.5523 0.999223 19.0001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.7500f35db0430ada6ac0dd63ae0de71d.svg";
export { ForwardRef as ReactComponent };